<template>
  <el-dialog
      :title="isEdit?'编辑用户':'添加用户'"
      @open="init"
      @close="doClose"
      :destroy-on-close="true"
      :append-to-body="true"
      :modal-append-to-body="true"
      :visible.sync="visible"
      width="400px">
    <div class="new_project_body">
      <el-form class="widget-form" :model="info" label-width="60px" size="medium" ref="record-form">
        <el-form-item prop="trueName" label="姓名">
          <el-input v-model="info.trueName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item prop="age" label="年龄">
          <el-input v-model="info.age" placeholder="请输入年龄"></el-input>
        </el-form-item>
        <el-form-item prop="unit" label="公司">
          <el-input v-model="info.unit" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item prop="department" label="部门">
          <el-input v-model="info.department" placeholder="请输入部门名称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="small" @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
      <el-button size="small" type="primary" @click="saveRecord()"><i class="fa fa-save"></i> 确定</el-button>
    </div>
  </el-dialog>

</template>

<script>
import { editUser } from '@/api/manage/company'

export default {
  props: {
    echo:null,
    visible: false
  },
  computed: {
    isEdit() {
      return this.echo
    }
  },
  data() {
    return {
      info: {}
    }
  },
  methods: {
    init() {
      console.info(this.echo)
      this.info = this.echo
    },
    saveRecord() {
      let { trueName, unit, department, age,id } = this.info
      this.$refs['record-form'].validate(valid => {
        if (valid) {
          editUser(this.info.projectId,this.info.userId,{ trueName, unit, department, age,id }).then(res => {
            this.$message.success('修改成功')
            this.$emit('done', true)
          })
        }
      })
    },
    doClose() {
      this.$emit('done', false)
    }
  }
}
</script>

